define(['underscore'],
    (_)=> {
        function Driver(data) {
            if (data) {
                _.extend(this, data);
                if (!data.dateOfBirth) {
                    data.dateOfBirth = null;
                }
            }
        }

        Driver.prototype.getDisplayName = function (defaultName, $filter) {
            if (this.person.firstName === '0streamlinedquote0') {
                return '';
            }
            return this.person.getDisplayName(defaultName, $filter);
        };

        Driver.prototype.getDriverStatesForCountry = (states, countryCode)=> {
            return _.filter(states, (state)=> {
                const countryConstraint = _.find(state.categories, (constraint)=> {
                    return _.keys(constraint).indexOf('Country') !== -1;
                });
                if (countryConstraint) {
                    return countryConstraint.Country === countryCode;
                }
                return false;
            });
        };


        return Driver;
    }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/models/Driver.js
 **/